import React from 'react'
import '../assets/css/style.css';
import '../style/HomeScreen.css'


const HangingBannerUI = () => { return (
    <div className="hanging-banner">
        <a
          href="https://www.ccilindia.com/Research/Statistics/Pages/TenorwiseIndicativeYields.aspx"
          target="_blank"
          className="swing animated infinite"
        >
          Tenor-wise Indicative Yields <i className="ri-arrow-down-line"></i>
        </a>
      </div>) };export default HangingBannerUI;